import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { findIndex as _findIndex } from 'lodash';

import EntityPropsUpdater from 'component/EntityPropsUpdater';
import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';
import Entity from 'components/Entity';

import CmsCanvas from 'components/cms/CmsCanvas';

import { entityMetaMapping } from 'js/constants';

class WhiteLabelPluginDetailedDescription extends EntityPropsUpdater {
  // make sure there is a CMS detailed description for given language
  getDetailedDescriptionEntity = () => {
    const { entity, appIntl } = this.props;

    const detailedDescriptionIndex = _findIndex(entity.getDetailedDescription(), ['language', appIntl.displayIntlForm]);
    if (detailedDescriptionIndex > -1) {
      return this.getEntityForCms(entity.getDetailedDescription()[detailedDescriptionIndex]);
    }

    // create new value and return it
    const newValue = entity.getDetailedDescription().slice();
    const newDetailedDescription = entity.createValue('detailedDescription', [], {
      language: appIntl.displayIntlForm,
    });
    newValue.push(newDetailedDescription);

    this.updateEntity('detailedDescription', newValue);

    return this.getEntityForCms(newDetailedDescription);
  };

  getEntityForCms = data => {
    const entity = new Entity();
    entity.setData(data);
    entity.setMeta(this.props.meta, entityMetaMapping.cmsDescription);

    return entity;
  };

  updateDetailedDescription = content => {
    const { entity, appIntl } = this.props;
    const detailedDescriptionIndex = _findIndex(entity.getDetailedDescription(), ['language', appIntl.displayIntlForm]);
    this.updateEntity('content', content, ['detailedDescription', detailedDescriptionIndex.toString()]);
  };

  render() {
    const {
      intl: { messages },
      entityLoaded,
    } = this.props;

    return (
      <div class="clearfix">
        {entityLoaded && (
          <Row>
            <Col xs={12}>
              <div class="p-t-15 p-b-15">
                <IntlFormInlineSelector /> {messages.detailed_description}
              </div>
              <CmsCanvas
                editMode
                entity={this.getDetailedDescriptionEntity()}
                changeEntity={detailedDescriptionEntity => {
                  this.updateDetailedDescription(detailedDescriptionEntity.processedData.content);
                }}
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
WhiteLabelPluginDetailedDescription.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    meta: state.entityMeta,
  };
};

export default injectIntl(connect(mapStateToProps)(WhiteLabelPluginDetailedDescription));
